import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, from, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class VectorBffAuthInterceptorService implements HttpInterceptor {
	private vectorBffBaseUri = environment.vectorBffConfig.uri.replace(/\/+$/, '');

	constructor(private msalService: MsalService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!this.isVectorBffRequest(req.url) || req.headers.has('Authorization')) {
			return next.handle(req);
		}

		const activeAccount = this.msalService.instance.getActiveAccount() ?? this.msalService.instance.getAllAccounts()[0];

		if (!activeAccount) {
			return throwError(() => new Error(`No active MSAL account for protected request: ${req.url}`));
		}

		return from(this.msalService.instance.acquireTokenSilent({
			account: activeAccount,
			scopes: environment.vectorBffConfig.scopes,
		})).pipe(
			switchMap((result) => {
				const authorizedRequest = req.clone({
					setHeaders: {
						Authorization: `Bearer ${result.accessToken}`,
					},
				});
				return next.handle(authorizedRequest);
			})
		);
	}

	private isVectorBffRequest(url: string): boolean {
		return url === this.vectorBffBaseUri || url.startsWith(`${this.vectorBffBaseUri}/`);
	}
}
